module.exports = __webpack_public_path__ + "img/coinbankB39.a9aacabe.jpg";